import React, { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';


function RingbaPubForm(props) {


    const handleChange = (e) => {
        const { name, value } = e.target;
        // Pass the field name and value to the parent's callback function
        props.onFormChange(name, value);
    };

    return (
        <>
            <h3>Create New Pub</h3>
            <Form>
                <Form.Group controlId="formAffiliateId">
                    <Form.Label>Affiliate ID</Form.Label>
                    <Form.Control 
                        name="affiliate_id" 
                        type="text" 
                        onChange={handleChange} 
                        value={props.formData.affiliate_id}
                        required 
                    />
                </Form.Group>
                <Form.Group controlId="formCampaignId">
                    <Form.Label>Campaign ID</Form.Label>
                    <Form.Control 
                        name="campaign_id" 
                        type="text" 
                        onChange={handleChange} 
                        value={props.formData.campaign_id} 
                        required 
                    />
                </Form.Group>
                <Form.Group controlId="formCreativeId">
                    <Form.Label>Creative ID</Form.Label>
                    <Form.Control 
                        name="creative_id" 
                        type="text" 
                        onChange={handleChange} 
                        value={props.formData.creative_id} 
                        required 
                    />
                </Form.Group>
                <Form.Group controlId="formSubAffiliate">
                    <Form.Label>Sub Affiliate (If Applicable)</Form.Label>
                    <Form.Control 
                        name="sub_affiliate" 
                        type="text" 
                        onChange={handleChange} 
                        value={props.formData.sub_affiliate} 
                    />
                </Form.Group>
                <Form.Group controlId="formTarget">
                    <Form.Label>Target (If Applicable)</Form.Label>
                    <Form.Control 
                        name="target" 
                        type="text" 
                        onChange={handleChange} 
                        value={props.formData.target} />
                </Form.Group>
                <Form.Group controlId="formPayout">
                    <Form.Label>Payout</Form.Label>
                    <Form.Control 
                        name="payout" 
                        type="text" 
                        onChange={handleChange} 
                        value={props.formData.payout} 
                        required 
                    />
                </Form.Group>
                <Form.Group controlId="formEmail">
                    <Form.Label>Affiliate Payout</Form.Label>
                    <Form.Control 
                        name="affiliate_payout" 
                        type="text" 
                        onChange={handleChange} 
                        value={props.formData.affiliate_payout}
                        required  
                    />
                </Form.Group>
                <Button style={{ width: '100%', marginTop: '10px' }} onClick={props.handleCreatePub} className="formButton" type="submit">
                    Create
                </Button>
               
            </Form>
        </>
    );
}

export default RingbaPubForm;
